export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const FORGOT_PASS = '/forgot-pass';
export const VERIFY_ACCOUNT = '/verify';
export const DOCS = '/docs';
export const TEAM = '/team';
export const CONTACT = '/contact';
export const ABOUT = '/about';
export const PRIVACY_DATA = '/privacy';
export const TC = '/tc';
export const PRICING = '/pricing'

/* MAIN HOME */
/// DASHBOARD - HOME
export const HOME = '/home';
export const LOGGED_IN_PRICING = '/home/pricing'
export const HOME_PROJECTS = '/home/projects';
export const HOME_FOLDERS = '/home/folders';
export const HOME_MESSAGES = '/home/messages';
export const HOME_COMPANY = '/home/company';
export const HOME_CREATE_PROJECT = '/home/create-project';
export const HOME_JOIN_PROJECT = '/home/join-project';
export const USER_PROFILE = '/home/me';
export const CREATE_NEW_COMPANY = '/home/create-company';
export const CREATE_JOIN_COMPANY = '/home/join-company';

/// PROJECT
export const IND_PROJECT = '/home/projects/asset';
export const IND_PROJECT_DASHBOARD = '/home/projects/asset/dashboard';
export const IND_PROJECT_FLOOR_MAP_EDITOR = '/home/projects/asset/dashboard/drawing';
export const IND_PROJECT_ELEVATION_MAP_EDITOR = '/home/projects/asset/dashboard/drawing/elevation';
export const IND_PRODUCT = '/product/:product_id';
export const HOME_IMAGE = '/home/image';
export const IND_CONSUMABLE = '/consumable/:con_id';
